var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 742"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z",
    fill: "#EFF3F5",
    stroke: "#2A2F3C",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.9997 10.333V12.1107C12.9997 12.3465 12.9061 12.5726 12.7394 12.7392C12.5727 12.9059 12.3466 12.9996 12.1109 12.9996H5.88886C5.65312 12.9996 5.42703 12.9059 5.26034 12.7392C5.09365 12.5726 5 12.3465 5 12.1107V10.333",
    stroke: "#404859",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.2187 7.22215L8.99656 5L6.77441 7.22215",
    stroke: "#404859",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9 5V10.3332",
    stroke: "#404859",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSvg);
export default __webpack_public_path__ + "static/media/upload-svg.77d578149b4b2043a98c8ed0e2f61678.svg";
export { ForwardRef as ReactComponent };